import { render } from "./PainelPddDashMain.vue?vue&type=template&id=2c8e4543&scoped=true"
import script from "./PainelPddDashMain.vue?vue&type=script&lang=js"
export * from "./PainelPddDashMain.vue?vue&type=script&lang=js"

import "./PainelPddDashMain.vue?vue&type=style&index=0&id=2c8e4543&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8e4543"]])

export default __exports__